import { AxiosInstance, AxiosResponse } from "axios";

import IMFilesPropertyDefinition from "src/backend/interfaces/mfiles/IMFilesPropertyDefinition";
import { SelectOption } from "../FilterOperatorSelect";
import { IMfilesObject } from "src/backend/interfaces/mfiles/IMFilesObject";
import { IMfilesPropertyFilter, IValueListFilter } from "src/backend/interfaces/filters/IFilter";
import { combineFilters } from "src/backend/services/FetchItemsService";
import { getLookupItemsAsync, getLookupItemsFilteredAsync } from "src/backend/services/FilterDataFetchService";
import { fetchSpecificObjectUrl } from "src/backend/helpers/urlHelper";

const LOOKUP_INPUT_ITEMS_LIMIT = 40;


export const sortAndFilterSelectOptions = (options: SelectOption[], searchTerm: string): SelectOption[] => {
  return options
    .sort((a,b) => a.label.trim().localeCompare(b.label.trim()))
    .filter((f) => searchTerm === null || searchTerm === "" || f.label.toLowerCase().includes(searchTerm.toLowerCase()));
}


export const getLookupSelection = (options: SelectOption[], selectedValues: string[]): SelectOption[] => {

  const selection: SelectOption[] = [];

  for ( let i = 0; i < selectedValues.length; i++ ) {

    const isSelected = options.find(option => option.value === selectedValues[i]);

    if ( isSelected ) {
      selection.push({value: isSelected.value, label: isSelected.label});
    }
  }
  return selection;
}


export const searchItems = async (
  searchTerm: string, 
  objectTypeId: number, 
  propertyDefinition: IMFilesPropertyDefinition,
  httpClient: AxiosInstance, 
): Promise<IMfilesObject[]> => {

  let results: IMfilesObject[] = [];

  // check static filter
  if ( propertyDefinition?.HasStaticFilter ) {

    const propFilters : IMfilesPropertyFilter[] = [];
    const vlFilters   : IValueListFilter[]     = [];

    for ( const filter of propertyDefinition.StaticFilters ) {

      if( filter?.PropertyDefOrObjectTypeArray?.ID ) {

        combineFilters(propFilters, {
          name: "Config filter",
          propertyId: filter?.PropertyDefOrObjectTypeArray?.ID,
          operator: filter?.ConditionType,
          value: filter?.TypedValue?.Lookup?.Item
        });

      } else if (filter.ValuelistID > 0) {
        //url param vl<filter.ValuelistID>=<filter.TypedValue.SerializedValue>

        vlFilters.push({
          id: filter?.ValuelistID, 
          operator: filter?.ConditionType,
          value: filter?.TypedValue.SerializedValue
        });
      }

    }

    results = await getLookupItemsFilteredAsync(httpClient, objectTypeId, searchTerm, propFilters, vlFilters, LOOKUP_INPUT_ITEMS_LIMIT);

  } else {
    results = await getLookupItemsAsync(httpClient, objectTypeId, searchTerm, LOOKUP_INPUT_ITEMS_LIMIT);
  }

  return results;
}

export const getSelectedObjectValues = async (
  httpClient: AxiosInstance,
  objectTypeId: number, 
  selectedValues: string[],
): Promise<SelectOption[]> => {

  const promises: Promise<AxiosResponse>[] = [];

  for ( const id of selectedValues ) {
    const fetchObjectUrl = fetchSpecificObjectUrl(objectTypeId, parseInt(id) );
    promises.push( httpClient.get<IMfilesObject>(fetchObjectUrl) );
  }

  const promisesResponses = await Promise.all( promises );

  const initialLookupOptions: SelectOption[] = [];
  for ( const itemResponse of promisesResponses ) {
    const item = itemResponse.data;
    initialLookupOptions.push( {value: item.ObjVer.ID.toString(), label: item.Title} )
  }

  return initialLookupOptions;
}